import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import Layout from '../components/ui/Layout';
import Home from '../pages/Home';
import '../assets/css/fonts.css';
import NotFound from "../pages/NotFound";
import Loading from "../components/common/Loading";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ContactPage from "../pages/ContactPage";
import WebApplicationDevelopment from "../pages/Services/WebApplicationDevelopment";
import MobileDevelopment from "../pages/Services/MobileDevelopment";
import CustomizedSoftware from "../pages/Services/CustomizedSoftware";
import ErpSolutions from "../pages/Services/ErpSolutions";
import CliniVista from "../pages/Products/CliniVista";

// ✅ Define all routes here
const router = createBrowserRouter([
  {
    path: '/',
    // loader: <Loading />,
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/loading', element: <Loading /> },
      // { path: '/about', element: <About /> },
      { path: '/contact', element: <ContactPage /> },
      // { path: '/careers', element: <Careers /> },
      { path: '/privacy-policy/', element: <PrivacyPolicy /> },
      {  path: '/services',
        children: [
          { path: 'web-application-development', element: <WebApplicationDevelopment /> },
          { path: 'mobile-development', element: <MobileDevelopment /> },
          { path: 'erp-solutions', element: <ErpSolutions /> },
          { path: 'customized-software', element: <CustomizedSoftware /> },
        ],
      },
      {  path: '/products',
        children: [
          { path: 'emr-clini-visita', element: <CliniVista /> },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

// ✅ Component to wrap RouterProvider and show Loading state
const Router = () => {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default Router;
